import React, { useEffect, useRef } from 'react';
import './Skillpointbox.css';
import NoItemView from '../NoItemView';
import Chart from 'chart.js/auto';
import { IBLSpinLoader } from '@iblai/ibl-web-react-common';
import { useTranslation } from 'react-i18next';

const Skillpointbox = ({
  skillPointsGraphData,
  skillPointsGraphDataLoaded,
}) => {
  const canvasRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (skillPointsGraphDataLoaded) {
      if (canvasRef.current) {
        canvasRef.current.destroy();
      }
      fillUpSkillPointsGraph(skillPointsGraphData);
    }
  }, [skillPointsGraphData, skillPointsGraphDataLoaded]);

  const fillUpSkillPointsGraph = (data) => {
    if (data && Object.keys(data).length > 0) {
      const labelData = Object.keys(data);
      const datasetPoints = labelData?.map(
        (skill) => data[skill]?.course_points
      );
      const ctx = document.getElementById('skillPointsGraph');
      canvasRef.current = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labelData,
          datasets: [
            {
              label: 'Points',
              data: datasetPoints,
              backgroundColor: [
                'rgba(113, 160, 204, 0.8)',
                'rgba(81, 205, 108, 0.8)',
                'rgba(104, 81, 205, 0.8)',
                'rgba(81, 205, 198, 0.8)',
                'rgba(204, 195, 113, 0.8)',
              ],
              borderWidth: 2,
              borderColor: [
                '#71a0cc',
                '#51cd6c',
                '#6851cd',
                '#51cdc6',
                '#ccc371',
              ],
            },
          ],
        },
        options: {
          indexAxis: 'y',
          scales: {
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      });
    }
  };

  return (
    <div className="pr_g f inp home sp">
      <div className="div-block-14">
        <div className="skm">
          {t('Skill Points')}
          <br />
        </div>
      </div>
      <div className="graphs-row">
        {!skillPointsGraphDataLoaded ? (
          <IBLSpinLoader size={40} />
        ) : skillPointsGraphData &&
          Object.keys(skillPointsGraphData).length > 0 ? (
          <div className="html-embed-2 skill-point dblock w-embed w-script">
            <canvas
              id="skillPointsGraph"
              style={{ width: '95%', height: '150px' }}
            ></canvas>
            <div style={{ textAlign: 'center', marginTop: 10 }}>Points</div>
          </div>
        ) : (
          <NoItemView
            imageUrl={'images/skills_icon_1skills_icon.png'}
            displayMessage={t('No skill points yet.\n')}
            displayPadding={false}
          />
        )}
      </div>
    </div>
  );
};
export default Skillpointbox;
